import { createSelector } from 'reselect'

import { selectSiteBuilderState } from 'core-components/sitebuilder/store/selectors/selectSitebuilderSelectors'

export const selectWidgets = createSelector([selectSiteBuilderState], ({ widgets }) => widgets)
